import {useParams, useRouteMatch} from 'react-router-dom';
import {DeviceForm} from '../../../../../../../components/device-form/device-form';
import {CaregiverMode} from '../../../../../../../enums';

export default function DeviceDetailsSystemAdministratorOfficeScreen() {
  // Get params
  let {id, deviceId}: {id?: string; deviceId?: string} = useParams();
  let currentDeviceId = deviceId || id;
  if (currentDeviceId?.toLowerCase() === 'create') {
    currentDeviceId = undefined;
  }

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <DeviceForm
      caregiverMode={CaregiverMode.SystemAdministrator}
      canWrite={true}
      showPageTitle={currentDeviceId ? false : true}
      redirectUrl={
        currentDeviceId
          ? `${url.replace(`/${currentDeviceId}`, '')}`
          : `${url.replace('/create', '')}`
      }
    />
  );
}
